import { StringSchema } from 'yup';

const validate = (value: string): boolean => value.length === 8 || value.length === 9;

export default function (this: StringSchema, message = 'Digite um RNTRC válido.') {
  return this.test('rntrc', message, (value) => validate(value));
}
